import { UPDATE_TECHNICAL_ISSUE } from '@/constants/mutation-types';

export default ({ commit, dispatch }, formData) => {
  commit(UPDATE_TECHNICAL_ISSUE, formData);

  return dispatch('save');
};
